module.exports = __webpack_public_path__ + "img/16.3d93708f.png";